export enum NationaltyType {
  National,
  Foreign,
}

export const nationaltyTypeValues: { [id: number]: string } = {
  0: 'Nacional',
  1: 'Extranjera',
};

export namespace NationaltyType {
  export function values() {
    return Object.keys(NationaltyType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: nationaltyTypeValues[index], value: index };
      });
  }
}
